import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Typography from "@mui/material/Typography";
import Initiatives from "./initiatives";
import SuppliersInitiatives from "./suppliers-intiatives";
import logo from "../../../assets/logo.png";
import { Card, Divider, Button } from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import { setNotificationMailData } from "../../as2-onboarding-component/utils/postJsons";
import { useOktaAuth } from "@okta/okta-react";
import { useNotificationAPI } from "../../as2-onboarding-component/hooks/useClient";
import { useClient } from "../../as2-onboarding-component/hooks/useClient";
import {NavLink} from "react-router-dom";

const steps = ["Verbiage", "Suppliers", "Confirm", "Created"];

export default function AddInitiatives() {
  const { oktaAuth } = useOktaAuth();
  const notificationApi = useNotificationAPI(oktaAuth.getAccessToken());
  const sterlingAPI = useClient(oktaAuth.getAccessToken());

  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [formData, setFormData] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [notificationSent, setNotificationSent] = useState(false);
  const [isSendingMail, setIsSendingMail] = useState(false);

  // check if form is completed, this is found at Initiatives.js
  const isFormComplete = formData.isValid;
  const isDevl = process.env.REACT_APP_OKTA_SCOPE === "scs-dev";

    const postNotification = async () => {
    const postSuppliers = Array.from(
      new Set(suppliers.map((supplier) => supplier.supplier_number))
    );

    try {
        const formDataToSend = new FormData();

        // Generate notification multipart
        formDataToSend.append("notification", JSON.stringify(formData));

        ///Generate suppliers multipart
        formDataToSend.append('suppliers',JSON.stringify(postSuppliers));

        //Generate attachments multipart - if any
        if (attachments && attachments.length > 0) {
            attachments.forEach((attachment, index) => {
                // Append each attachment blob to the FormData
                formDataToSend.append(`attachments`, attachment);
            });
        }
        const response = await notificationApi.post("/notifications", formDataToSend, {
            headers: {
                ...notificationApi.defaults.headers.common,
                "Content-Type": "multipart/form-data",
            },
        });

      console.log("Notification created:", response.data);
    } catch (error) {
      console.error("Error creating notification:", error);
    }
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const setSuppliersEmails = () => {
    const supplier_emails = [];

    suppliers.map((supplier) => {
      console.log("supplier", supplier);
      if (supplier.supplier_email) {
        supplier_emails.push(supplier.supplier_email);
      }
    });

    return supplier_emails;
  };

  const sendEmailsToSuppliers = async () => {
    try {
        //Send mail to every supplier email
        if (isDevl) {
            console.log("Skipping email sending in devl environment");
            return true;
        }

        const results = await Promise.all(
          suppliers.map(async (supplier) => {
            try {
              console.log("Sending email to: ", supplier.supplier_email);

              const emailPayload = setNotificationMailData(
                  supplier.supplier_email,
                  supplier.supplier_number,
                  formData.title,
                  formData.notification_text.replace(/\n/g, "<br />")
              );

              const response = await sterlingAPI.post(
                  "scs/rcs/email",
                  emailPayload
              );

              console.log("Email sent successfully with response:", response.status);
              return response.status === 204;
            } catch (error) {
              console.error("Error sending email to:", supplier.supplier_email, error);
              return false;
            }
          })
      );

      // Verify all mails were sent
      const allSuccessful = results.every((status) => status === true);
      return allSuccessful;
    } catch (error) {
      console.error("Unexpected error while sending mail:", error);
      return false;
    }
  };

  const handlesubmit = (data, attachments) => {
    setFormData(data);
    setAttachments(attachments)
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleComplete = () => {
    setCompleted({
      ...completed,
      [activeStep]: true,
    });
    handleNext();
  };

  useEffect(() => {
    const sendData = async () => {
      if (activeStep === 3 && completed[2]) {
        setIsSendingMail(true);
        try {
          const emailsSentSuccess = await sendEmailsToSuppliers();
          if (emailsSentSuccess) {
            //Only create notification record if emails were sent successfully
            console.log("Emails sent successfully, creating notification...");
            await postNotification();
            setNotificationSent(true);
          } else {
            console.error("Email failed, notification not created.");
            setNotificationSent(false);
          }
        } catch (error) {
          console.error("Error sending data:", error);
          setNotificationSent(false);
        }finally {
          setIsSendingMail(false);
        }
      }
    };

    sendData();
  }, [completed]);

  return (
    <Box sx={{ width: "100%" }} >
      <Stepper nonLinear activeStep={activeStep} style={{ width: "100%" }}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit">{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        <React.Fragment>
          <Box p={2}>
            <Card
              style={{
                width: "100%",
                padding: "30px 30px 30px 30px",
                marginTop: "20px",
              }}
            >
              {activeStep === 0 && <Initiatives onFormSubmit={handlesubmit} />}
              {activeStep === 1 && (
                <SuppliersInitiatives
                  suppliers={suppliers}
                  setSuppliers={setSuppliers}
                />
              )}
              {activeStep === 2 && (
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      margin: "0.90rem",
                    }}
                  >
                    <img
                      src={logo}
                      alt="Company logo"
                      style={{
                        marginRight: 16,
                        width: 65,
                        height: 65,
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Typography size="lg" fontWeight="bold" component="h1">
                        <strong>{formData.initiativeName}</strong>
                      </Typography>
                      <Typography variant="subtitle1">
                        {formData.title}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "36px",
                        marginLeft: "auto",
                        marginRight: "1rem",
                      }}
                    >
                      <Typography variant="subtitle1">
                        Priority: <strong>{formData.priority}</strong>
                      </Typography>
                      <Typography variant="subtitle1">
                        Due date:
                        <strong>
                          {formData.due_date ? formData.due_date : " N/A"}
                        </strong>
                      </Typography>
                    </Box>
                  </Box>

                 <Typography sx={{ whiteSpace: 'pre-line' }}>
                  {formData.notification_text}
                </Typography>

                  <div>
                    <Divider
                      style={{
                        height: "1px",
                        backgroundColor: "#dddd",
                        width: "100%",
                        margin: "0 auto",
                      }}
                    />
                  </div>
                </Box>
              )}
              {activeStep === 3 ? (
                  // results screen
                  isSendingMail ? (
                      <LoadingCard/>
                  ) : notificationSent ? (
                      <SuccessCard suppliers={suppliers}/>
                  ) : (
                      <FailureCard/>
                  )
              ) : (
                  <Box sx={{display: "flex", justifyContent: "end", pt: 2}}>
                    <Button
                        size="medium"
                        variant="secondary"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                    >
                      Cancel
                    </Button>
                    {activeStep !== steps.length && (
                        <Button
                            onClick={handleComplete}
                            variant="primary"
                            size="medium"
                            sx={{ mr: 1 }}
                            disabled={!isFormComplete}
                        >
                          Next
                        </Button>
                    )}
                  </Box>
              )}
            </Card>
          </Box>
        </React.Fragment>
      </div>
    </Box>
  );
}

const LoadingCard = () => (
    <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "62vh",
          textAlign: "center",
        }}
    >
      <CircularProgress color="primary" />
      <Typography color="grey" fontWeight="600" component="h2" variant="h1">
        Sending emails and creating notification...
      </Typography>
    </Box>
);

const SuccessCard = ({suppliers}) => (
    <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "62vh",
          textAlign: "center",
          position: "relative",
        }}
    >
      <CheckCircleIcon fontSize="medium" color="success" />
      <Typography color="grey" fontWeight="600" component="h2" variant="h1">
        Created successfully
      </Typography>
      <Box sx={{ position: "absolute", bottom: "10%", width: "100%" }}>
        <Divider
            sx={{
              height: "1px",
              backgroundColor: "#ddd",
              width: "100%",
            }}
        />
        <Typography
            color="grey"
            fontWeight="600"
            component="h2"
            variant="h3"
            mt={2}
        >
          Created and sent to {suppliers.length} suppliers
        </Typography>
      </Box>
    </Box>
);

const FailureCard = () => (
    <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "62vh",
          textAlign: "center",
          position: "relative",
        }}
    >
      <ErrorIcon fontSize="medium" color="error" />
      <Typography color="error" fontWeight="600" component="h2" variant="h1">
        There was an error while sending the notification
      </Typography>
      <Box sx={{ position: "absolute", bottom: "10%", width: "100%" }}>
        <Divider
            sx={{
              height: "1px",
              backgroundColor: "#ddd",
              width: "100%",
            }}
        />
        <Typography
            color="grey"
            fontWeight="600"
            component="h2"
            variant="h3"
            mt={2}
        >
          Please, <NavLink to="/ediSelfServicePortal/admin">try again...</NavLink>
        </Typography>
      </Box>
    </Box>
);

